"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * A hook providing `open` state for a `Tooltip` and a default set of event
 * handlers to assign to the containing element that should control its
 * visibility.
 */
function useTooltipState(
/**
 * Whether the tooltip is initially open.
 */
initialState) {
    if (initialState === void 0) { initialState = false; }
    var _a = (0, react_1.useState)(initialState), open = _a[0], setOpen = _a[1];
    return {
        open: open,
        setOpen: setOpen,
        handlers: (0, react_1.useMemo)(function () { return ({
            onMouseEnter: function () {
                setOpen(true);
            },
            onMouseLeave: function () {
                setOpen(false);
            },
            onFocus: function () {
                setOpen(true);
            },
            onBlur: function () {
                setOpen(false);
            },
        }); }, [setOpen]),
    };
}
exports.default = useTooltipState;
